/** minutes in an hour, for splitting a total into hours and minutes */
export const minutesPerHour = 60;
